import React from "react";
import { format } from "lib/globalize-util";
import { ConfirmDialog } from "components/dialog";
import { IModalProps } from "../common";
import { styles } from "./styles";
import { DATATEST } from "constants/integration";

export const deleteSelectedPromotions = "Would you like to delete selected promotions?";
export const deleteOneSelectedPromotion = "Would you like to delete this promotion entirely?";
export const promotionsWillBeDeleted = "Promotions will be deleted";
export const onePromotionWillBeDeleted = "Promotion will be deleted";
export const deletePromotionsConfirmation = "Yes, Delete Promotions";
export const deleteOnePromotionConfirmation = "Yes, Delete Promotion";

export const DeleteConfirmationModal: React.FC<IModalProps> = ({ open, onConfirm, onClose, isBulkAction }) => {
    const text = isBulkAction ? format(deleteSelectedPromotions) : format(deleteOneSelectedPromotion);
    const title = isBulkAction ? format(promotionsWillBeDeleted) : format(onePromotionWillBeDeleted);
    const label = isBulkAction ? format(deletePromotionsConfirmation) : format(deleteOnePromotionConfirmation);

    return (
        <ConfirmDialog
            dataTestConfirm={DATATEST.PROMOTIONS.DELETE_MODAL_DIALOG_CONFIRM}
            dataTestCancel={DATATEST.PROMOTIONS.DELETE_MODAL_DIALOG_CANCEL}
            open={open}
            onConfirm={onConfirm}
            onCancel={onClose}
            onRequestClose={onClose}
            contentStyle={styles.confirmDialog}
            title={title}
            cancelLabel={format("Cancel")}
            confirmLabel={label}
        >
            {text}&nbsp;
            {format("Are you sure you want to proceed?")}
        </ConfirmDialog>
    );
};
